import React from 'react';

import SwensensHR from './SwensensHR';
import Voucher, { getExpiryForAdditionalVoucher } from './Voucher';

import { VoucherLikePromo, showPromo, PROMOTIONS } from './Promotions';

import { VerticalSeparator } from './utils';
import { daysElapsedSince, extractRecentVoucherRedemptionsFromMemberData } from './utils';

export default function VouchersView({ token, memberData, updateMemberData }) {
    const cardId = token.split(':')[1];
    const name = memberData?.MemberInfo?.Name;

    const activePromotions = PROMOTIONS.filter(p => showPromo(p.component, memberData));

    const voucherLists = (memberData?.VoucherLists || []).filter(voucher => {
        const expiryDate = new Date(Number(voucher.ValidTo.match(/\/Date\(([0-9]+)\)\//)[1]) + 1000 * 60 * 60 * 24 - 1);
        return expiryDate > new Date();
    });

    const additionalVouchers = (memberData?.__additional_vouchers__ || []).filter(voucher => {
        const exactExpiryTimestamp = getExpiryForAdditionalVoucher(voucher, memberData);
        return exactExpiryTimestamp.getTime() > (new Date()).getTime();
    });

    console.log(`Vouchers for ${name} (${cardId}):`, voucherLists, additionalVouchers);

    const recentlyRedeemedVouchers = extractRecentVoucherRedemptionsFromMemberData(memberData)
        .filter(redemption => daysElapsedSince(redemption.ts) < 7)
    console.log(`Last Redeemed Vouchers for ${name} (${cardId}):`, voucherLists, recentlyRedeemedVouchers);

    return (
        <>
            {(activePromotions.length + voucherLists.length + additionalVouchers.length) > 0 && (
                <>
                    {
                        activePromotions.map(({ name, component: PromotionModalComponent }, idx) => (
                            <VoucherLikePromo key={`voucher-like-promo-${name}-${idx}`}
                                PromotionModalComponent={PromotionModalComponent}
                                onlyShowImage={!!PromotionModalComponent.__onlyShowImage__}
                                token={token}
                                memberData={memberData}
                                updateMemberData={updateMemberData}
                            />
                        ))
                    }
                    {
                        activePromotions.length > 0 && (
                            <VerticalSeparator height='6px'/>
                        )
                    }
                    <p className="app-text">
                        <strong>My eVouchers</strong>
                    </p>
                    {
                        voucherLists.map((voucher, idx) => (
                            <Voucher key={`voucher-${idx}-${voucher.VoucherNo}`}
                                voucher={voucher}
                                token={token}
                                ownCardNumber={cardId}
                                updateMemberData={updateMemberData}
                                lastRedemptionRecord={recentlyRedeemedVouchers.find(item => item.voucherNumber === voucher.VoucherNo)}
                                memberData={memberData} />
                        ))
                    }
                    {
                        additionalVouchers.map((voucher, idx) => (
                            <Voucher key={`additional-voucher-${idx}-${voucher.vid || voucher.VoucherNo}`}
                                voucher={voucher}
                                voucherType='additional'
                                token={token}
                                ownCardNumber={cardId}
                                updateMemberData={updateMemberData}
                                lastRedemptionRecord={recentlyRedeemedVouchers.find(item => item.voucherNumber === voucher.vid)}
                                memberData={memberData} />
                        ))
                    }
                    <SwensensHR />
                </>
            )}
            {recentlyRedeemedVouchers.length > 0 && (
                <>
                    <p className="app-text">
                        <strong>Recently Redeemed eVouchers</strong>
                    </p>
                    {recentlyRedeemedVouchers.map(({ ts, data: { voucherData: voucher, voucherType } }, idx) => (
                        <Voucher key={`redeemed-voucher-${idx}`}
                            voucher={voucher}
                            voucherType={voucherType}
                            ownCardNumber={cardId}
                            redemptionDate={ts}
                            memberData={memberData}
                            redemptionRecord={recentlyRedeemedVouchers[idx]} />
                    ))}
                    <SwensensHR />
                </>
            )}
        </>
    );
}
